import Cookies from 'universal-cookie';

import type { AccountHolderProfile } from '../declarations/auth-api';
import makeCall from './caller';
import { fetchToken } from './token';

// returns validated AhProfile or null

const cookies = new Cookies();

export async function fetchProfile(): Promise<AccountHolderProfile | null> {
  const ppToken = fetchToken();
  if (!ppToken) {
    return null;
  }
  try {
    const data = await makeCall<AccountHolderProfile>({
      call: {
        job: 'getProfile',
        section: 'auth',
      },
      headers: {
        'pp-token': ppToken,
      },
    });
    return data;
  } catch {
    // local cookie
    cookies.remove('pp-token');
    // as well as global cookie
    cookies.remove('pp-token', {
      domain: window.location.hostname.split('.').slice(-2).join('.'), // pureprofile.com
    });
    return null;
  }
}
